import Vue from 'vue';
import GiftComponent from './Index.vue';

export default {
  showGiftDialog({
    context = null,
    meta,
    option,
  } = {}) {
    return new Promise(() => {
      const GiftComponentCreator = Vue.extend(GiftComponent);

      const giftComponent = new GiftComponentCreator({
        el: document.createElement('div'),
        created() {
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          this.icon = '';
          meta.iconList.forEach((element) => {
            if (element.packageId === meta.packageInfo.package_id) {
              this.icon = element.icon;
            }
          });
          this.packageData = meta.packageInfo;
          this.option = Object.assign({}, option, {
            height: isMobile ? '6rem' : '500px',
            width: isMobile ? '7rem' : '700px',
            fotter: true,
            close: true,
            header: '温馨提示',
            cancel: false,
            confirm: !!option?.confirmStyle?.backgroundImage,
          });
          this.$on('fill-address', () => {
            Vue.prototype.$eventBus.$emit('ceiba:common:events:address-fill');
            this.$destroy();
          });

          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(giftComponent.$el);
    });
  },
};

// {
//   ret: 0,
//   msg: '恭喜您获得了礼包： 清凉币 ',
//   data: {
//     ret: 0,
//     msg: '恭喜您获得了礼包： 清凉币 ',
//     ams_code: '0',
//     ams_code_msg: '恭喜您获得了礼包： 清凉币 ',
//     serial: 'AMS-peng-0527142152-WmM4rr-484800-68125',
//     package_id: '3260877',
//     package_name: '清凉币',
//     package_real_flag: '1',
//     id: '388136966',
//     gifts: [{
//       package_id: '3260877',
//       num: 1,
//       real_flag: '1'
//     }],
//     package_cdkey: ''
//   },
//   serialId: 'ceiba-ingame-10252-7513-1653632512877-3b90e9c2fa'
// };
